import React from "react";
import { Dropdown, Tooltip, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./CreateEvent.scss";
import {
  faGlobe,
  faInfoCircle,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";
import Header from "../../Header";
import useCreateEvent from "./useCreateEvent";
import TextEditor from "../../Editor";
import { eventDurationsConst } from "./constants";

import "./CreateEvent.scss";
import Footer from "../../Footer/Footer";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import MainLayout from "../../MainLayout";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const {
    formData,
    editorOpen,
    calendarAvailabilityLists,
    calendarEventAvailability,
    formInputsError,

    onFormInputChange,
    handleEditorOpen,
    onFormSubmit,
    onCancelClick,
    onAvailabilityChange,
    onAddAvailabilty,
    onBackHandler,
  } = useCreateEvent();

  return (
    <MainLayout pageName={"Create Event"}>
      <div className="create-event-wrapper">
        <div className="container">
          <div className="top d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <button
                className="bg-transparent text-primary border-0 font-weight-medium fsm mr-3"
                onClick={onBackHandler}
              >
                <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
                Back
              </button>
            </div>
            <button
              onClick={onAddAvailabilty}
              className="btn btn-outline-primary ml-auto"
            >
              Availability
            </button>
          </div>
        </div>
        <div className="py-4">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                    <div className="bg-white p-3 border border-radius-10">
                      <h3 className="mb-3">Event Details</h3>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="">
                              <span className="text-danger">* </span>Event Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Event Name"
                              name="title"
                              onChange={(e) => {
                                onFormInputChange(e);
                              }}
                              defaultValue={formData?.title}
                            />
                          </div>

                          {formInputsError?.title && (
                            <p className="text-danger">
                              {formInputsError?.title}
                            </p>
                          )}
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="">
                              Description/Instructions
                            </label>
                            <div className="custom-text-editor">
                              {editorOpen ? (
                                <TextEditor
                                  htmlData={formData && formData?.description}
                                  getHtmlData={(data) =>
                                    onFormInputChange({
                                      target: {
                                        value: data,
                                        name: "description",
                                      },
                                    })
                                  }
                                />
                              ) : (
                                <div
                                  onClick={() => handleEditorOpen()}
                                  className="p-2 rounded border"
                                >
                                  {formData?.description &&
                                    Array.isArray(formData?.description) &&
                                    formData?.description.length > 0 ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: formData?.description,
                                      }}
                                    ></div>
                                  ) : (
                                    <p>Click to add description.</p>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="">
                              <span className="text-danger">* </span>
                              Date range (Days into the Future)
                              <span>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="button-tooltip-1">
                                      Set a range of dates when you can accept
                                      meetings.
                                    </Tooltip>
                                  }
                                >
                                  {({ ref, ...triggerHandler }) => (
                                    <span
                                      variant="light"
                                      {...triggerHandler}
                                      className="d-inline-flex align-items-center"
                                    >
                                      <span className="ml-3" ref={ref}>
                                        <FontAwesomeIcon
                                          icon={faInfoCircle}
                                          className="text-warning"
                                        />
                                      </span>
                                    </span>
                                  )}
                                </OverlayTrigger>
                              </span>
                            </label>
                            <input
                              type="number"
                              min="2"
                              max="100"
                              className="form-control"
                              placeholder="Enter No. of Days"
                              name="interview_before"
                              onChange={(e) => {
                                onFormInputChange(e);
                              }}
                              defaultValue={formData?.interview_before}
                            />
                            <p className="text-grey-4 mt-2">
                              Invitees can schedule...
                            </p>
                          </div>
                          {formInputsError?.interview_before &&
                            formInputsError.interview_before.length > 0 && (
                              <p className="text-danger">
                                {formInputsError?.interview_before}
                              </p>
                            )}
                        </div> */}
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="">
                              <span className="text-danger">* </span>
                              Event Duration (in Mins)
                              <span>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="button-tooltip-2">
                                      Define how long your event will be. It can
                                      be as long as 12 hours.
                                    </Tooltip>
                                  }
                                >
                                  {({ ref2, ...triggerHandler }) => (
                                    <span
                                      variant="light"
                                      {...triggerHandler}
                                      className="d-inline-flex align-items-center"
                                    >
                                      <span className="ml-3" ref={ref2}>
                                        <FontAwesomeIcon
                                          icon={faInfoCircle}
                                          className="text-warning"
                                        />
                                      </span>
                                    </span>
                                  )}
                                </OverlayTrigger>
                              </span>
                            </label>
                            <span className="select">
                              <select
                                name="duration"
                                onChange={onFormInputChange}
                                className="form-control"
                              >
                                <option
                                  disabled={true}
                                  value=""
                                  selected={formData?.duration === null}
                                >
                                  Select Event Duration
                                </option>
                                {Array.isArray(eventDurationsConst) &&
                                  eventDurationsConst.map((item) => (
                                    <option
                                      key={item}
                                      selected={formData?.duration === item}
                                      defaultValue={item}
                                    >
                                      {item}
                                    </option>
                                  ))}
                              </select>
                            </span>
                          </div>

                          {formInputsError?.duration && (
                            <p className="text-danger">
                              {formInputsError?.duration}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                  {formData?.id && (
                    <>
                        <div className="p-3 bg-white border border-radius-10 mt-3">
                        <h3 className="mb-3">
                          Which schedule do you want to use?
                        </h3>
                          <div className="row">
                            <div className="col-lg-6 mb-3">
                              <label htmlFor="">
                                <span className="text-danger">* </span>
                                Availability
                              </label>
                              <div className="form-group">
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant=""
                                    className="form-control text-left d-flex align-items-center justify-content-between"
                                  >
                                    {calendarEventAvailability?.availability_details
                                      ? calendarEventAvailability?.availability_details &&
                                      calendarEventAvailability
                                        ?.availability_details.title
                                      : "Select Availability"}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="timezone-selector-dropdown py-3 px-3">
                                    {calendarAvailabilityLists &&
                                      Array.isArray(
                                        calendarAvailabilityLists
                                      ) &&
                                      calendarAvailabilityLists.map((item) => (
                                        <DropdownItem
                                          className="cursor-pointer py-2 font-weight-semi"
                                          key={item?.id}
                                          onClick={() =>
                                            onAvailabilityChange(item?.id)
                                          }
                                        >
                                          {item?.title}
                                        </DropdownItem>
                                      ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                            {/* <div className="col-lg-6 mb-3">
                              <label htmlFor="">
                                <span className="text-danger">* </span>
                                Time Zone
                              </label>
                              <div className="form-group">
                                <p
                                  className="text-capitalize mb-0 d-flex align-items-center  form-control"
                                  disabled
                                >
                                  <FontAwesomeIcon
                                    icon={faGlobe}
                                    className="text-primary mr-2"
                                  />{" "}
                                  {formData?.event_creator &&
                                    formData.event_creator?.timezone}
                                </p>
                              </div>
                            </div> */}
                            <div className="col-lg-12">
                              {calendarEventAvailability?.availability_details && (
                                <div className="row align-items-start flex-wrap justify-content-between align-items-center">
                                  <ul className="days-listings col-lg-7">
                                    {calendarEventAvailability?.availability_details &&
                                      Array.isArray(
                                        calendarEventAvailability?.availability_details
                                      ) &&
                                      calendarEventAvailability.availability_details.days.map(
                                        (item) => (
                                          <li
                                            className="d-flex align-items-center mb-3 day-item"
                                            key={item?.id}
                                          >
                                            <span className="font-weight-bold text-capitalize day-name">
                                              {item && item?.day}
                                            </span>
                                            {Array.isArray(item?.time) &&
                                              item?.time &&
                                              item.time.map((interval) => (
                                                <div className="ml-5">
                                                  <p
                                                    key={interval?.id}
                                                    className="mb-0"
                                                  >
                                                    <span className="day-interval">
                                                      {interval?.start_time}
                                                    </span>{" "}
                                                    <span className="d-inline-block px-2 text-center">
                                                      –
                                                    </span>
                                                    <span className="day-interval">
                                                      {interval?.end_time}
                                                    </span>
                                                  </p>
                                                </div>
                                              ))}
                                          </li>
                                        )
                                      )}
                                  </ul>
                                  <div className="text-grey-4 col-lg-5 px-lg-5">
                                    <p>Set your weekly hours</p>
                                    <p>
                                      To override your hours on specific dates,
                                      update your schedule under Availability.
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                    </>
                  )}

                  <div className="action py-3 d-flex align-items-center">
                    <button className="btn btn-outline-light bg-white border-radius-10" onClick={onCancelClick}>
                      {" "}
                      Cancel{" "}
                    </button>
                    <button
                      className="btn btn-light ml-2 border-radius-10"
                      onClick={onFormSubmit}
                    >
                      {" "}
                      {formData?.id ? "Submit" : "Save"}
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
